import { observable } from "mobx";

export class Scoreboard {
    @observable onServe?: string;
    @observable additionalScoreData1: string[];
    @observable additionalScoreData2: string[];

    constructor(source: any) {
        this.onServe = source.onServe;
        this.additionalScoreData1 = source.additionalScoreData1;
        this.additionalScoreData2 = source.additionalScoreData2;
    }
}